import * as interactions from 'ol/interaction';
import { useEffect } from 'react';
import { useOpenLayers } from '../react-ol';
var interactionMap = {
  altShiftDragRotate: interactions.DragRotate,
  doubleClickZoom: interactions.DoubleClickZoom,
  mouseWheelZoom: interactions.MouseWheelZoom,
  dragPan: interactions.DragPan,
  shiftDragZoom: interactions.DragZoom
};
/**
 * Removes given interaction from the map object
 *
 * @param interaction altShiftDragRotate | doubleClickZoom | mouseWheelZoom | shiftDragZoom | dragPan
 *
 * Should be used within map context
 */

export default function useDisableInteraction(interaction) {
  var {
    map
  } = useOpenLayers();
  useEffect(() => {
    if (!map) return;
    var interactionToDisable = interactionMap[interaction];
    map.getInteractions().forEach(i => {
      if (i instanceof interactionToDisable) {
        map.removeInteraction(i);
      }
    });
  }, [map, interaction]);
}